import { createAction } from '@reduxjs/toolkit'

// app ui
export const actionSearch = createAction<boolean>('UI_SHOW_SEARCH')